import styled from "styled-components";
import { useContext, useEffect, useState } from "react";
import { DialogWindowContext } from "../../../../Contexts/DialogueWindowContext";
import { OrgTreeContext } from "../../../../Contexts/OrgTreeContext";
import { CurrentUserContext } from "../../../../Contexts/CurrentUserContext";
import {
  findParentNode,
  findNodeById,
} from "../../../../Helpers/OrgTreeFunctions";
import { generateRandomString } from "../../../../Helpers/ReportDataFunctions";
import EditTeamSettings from "./EditTeamSettings";

const TeamSettingsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  border: 1px solid var(--accent-color-dark);
  width: 90%;
`;
const Header = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  background-color: var(--accent-color-dark);
  color: white;
  padding: 10px 10px 10px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TeamInfo = styled.div`
  padding: 10px 10px 10px 5px;
  h3 {
    font-size: 17px;
    margin-bottom: 1px;
    color: var(--accent-color-dark);
  }
  p {
    font-size: 15px;
    margin-bottom: 6px;
  }
`;

const AddTeamButton = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 80px 80px 80px;
  padding: 10px 0;
  justify-items: center;
  align-items: center;
  border-top: 1px solid var(--accent-color-dark);
  font-weight: bold;
  text-align: center;
  grid-template-columns: 1fr;
  color: var(--accent-color-dark);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-bottom: none;
  @media (max-width: 550px) {
    grid-template-columns: 1fr 1fr 50px;
    padding: 7px 0px;
  }

  &:hover {
    background-color: var(--accent-color-dark);
    color: white;
  }
`;

export default function TeamSettings(props: Props) {
  const { selectedTeam } = props;
  const orgTreeDatabase = useContext(OrgTreeContext);
  const [parentTeam, setParentTeam] = useState<OrgTreeItem>();
  const [displayTeam, setDisplayTeam] = useState<OrgTreeItem>();
  const DialogWindow = useContext(DialogWindowContext);
  const userContext = useContext(CurrentUserContext);
  const user = userContext?.currentUser;

  useEffect(() => {
    if (selectedTeam && orgTreeDatabase) {
      const parentOfPropNode = findParentNode(orgTreeDatabase, selectedTeam);
      const selectedTeamNode = findNodeById(
        [orgTreeDatabase],
        selectedTeam.teamId
      );
      selectedTeamNode && setDisplayTeam(selectedTeamNode);
      parentOfPropNode && setParentTeam(parentOfPropNode);
    }
  }, [selectedTeam, orgTreeDatabase]);

  function camelCaseToCapitalized(str: string) {
    // Insert a space before all capital letters
    const result = str
      .replace(/([A-Z])/g, " $1")
      // Capitalize the first letter of each word
      .replace(/^./, (match) => match.toUpperCase())
      .replace(/ (\w)/g, (match) => match.toUpperCase());
    return result;
  }

  const showEditWindowHandler = () => {
    if (displayTeam) {
      DialogWindow.setDialogProps((prevProps) => ({
        ...prevProps,
        showEditWindow: true,
        header: `Team Setings Edit`,
        children: <EditTeamSettings selectedTeam={displayTeam} />,
      }));
    }
  };

  const showAddSubTeamWindowHandler = () => {
    if (displayTeam && orgTreeDatabase) {
      const newKey = displayTeam.children
        ? displayTeam.key + displayTeam.children.length
        : displayTeam.key + 0;
      const newTeam: OrgTreeItem = {
        teamId: generateRandomString(),
        label: "New Team",
        teamType: "campus",
        key: newKey,
        visible: true,
      };
      DialogWindow.setDialogProps((prevProps) => ({
        ...prevProps,
        showEditWindow: true,
        header: `New Sub Team`,
        children: <EditTeamSettings selectedTeam={newTeam} />,
      }));
    }
  };

  return (
    <TeamSettingsWrapper>
      <Header>
        <>Team Settings</>

        {user?.PCRoles.some(
          (role) => role.role === "admin" && role.teamId == "A1B2C3D4E0"
        ) && (
          <i
            className="pi pi-pencil"
            onClick={showEditWindowHandler}
            style={{ color: "white" }}
          ></i>
        )}
      </Header>
      {displayTeam && (
        <TeamInfo>
          <h3>Team Name:</h3>
          <p>{displayTeam.label}</p>

          <h3>Team Type:</h3>
          <p>{camelCaseToCapitalized(displayTeam.teamType)}</p>

          <h3>Active:</h3>
          <p>{displayTeam.visible ? "Yes" : "No"}</p>

          <h3>Parent Team:</h3>
          <p>{parentTeam?.label}</p>

          {displayTeam.children && (
            <>
              <h3>Sub Teams:</h3>
              {displayTeam.children
                .map((child) => {
                  if (
                    child.teamType !== "volunteer" &&
                    child.teamType !== "pastoralCare" &&
                    child.teamType !== "churchStaff" &&
                    child.teamType !== "admin" &&
                    child.teamType !== "campusPastor" &&
                    child.teamType !== "oversight"
                  ) {
                    return child.label;
                  }
                  return null;
                })
                .filter(Boolean)
                .join(", ")}{" "}
              <p></p>
            </>
          )}
        </TeamInfo>
      )}
      {userContext?.currentUser?.PCRoles.some(
        (role) => role.role === "admin"
      ) && (
        <AddTeamButton onClick={showAddSubTeamWindowHandler}>
          Add Sub Team
        </AddTeamButton>
      )}
    </TeamSettingsWrapper>
  );
}

interface Props {
  selectedTeam: OrgTreeItem;
}
